module.exports = __webpack_public_path__ + "static/media/exclamation-mark.f75e6bb5.svg";